import { AxiosPromise } from 'axios'
import axios from '../api/axios'
import { SubscribeRequestData, UnsubscribeRequestData } from './types'

export const subscribe = (data: SubscribeRequestData): AxiosPromise<void> =>
  axios.post<void>(`/orreca/v1/newsletters/subscribe`, data)

export const unsubscribe = (data: UnsubscribeRequestData): AxiosPromise<void> =>
  axios.post<void>(`/orreca/v1/newsletters/unsubscribe`, data)
